module.exports = __webpack_public_path__ + "img/vmc_aniv24_24Aug2021.9c433c8e.jpg";